/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_SetupInputs */

const cs_sreality_setup = /** @type {(inputs: Sreality_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastavit Sreality RK`)
};

const en_sreality_setup = /** @type {(inputs: Sreality_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set up Sreality RK`)
};

/**
* | output |
* | --- |
* | "Set up Sreality RK" |
*
* @param {Sreality_SetupInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_setup = /** @type {((inputs?: Sreality_SetupInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_SetupInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_setup(inputs)
	return cs_sreality_setup(inputs)
});